import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CheckoutContext } from "../context/checkout.context";
import { TripFiltersContext } from "../context/trip-filters.context";
import { getTotalPrice } from "../utils/coverage.utils";

// Número de dias da viagem (embarque e desembarque contam), igual ao
// "Permanência de X dias" mostrado na busca.
export const useTripDays = () => {
  const { boardingDate, arrivalDate } = useContext(TripFiltersContext);
  if (!boardingDate?.diff || !arrivalDate?.diff) return 0;
  return arrivalDate.diff(boardingDate, "days") + 1;
};

// Preço total, por dia e por pessoa de um plano, para a busca atual.
export const usePlanPrice = (insurance) => {
  const { youngPassengers, oldPassengers } = useContext(TripFiltersContext);
  const tripDays = useTripDays();
  const passengers = youngPassengers + oldPassengers;
  const total = getTotalPrice(insurance, youngPassengers, oldPassengers);
  return {
    total,
    passengers,
    // Com idades em faixas diferentes, o preço por pessoa é uma média.
    mixedAges: youngPassengers > 0 && oldPassengers > 0,
    perPerson: passengers > 0 ? total / passengers : total,
    perDay: tripDays > 0 ? total / tripDays : null,
  };
};

// Guarda o plano escolhido e vai para o checkout.
export const useSelectInsurance = () => {
  const navigate = useNavigate();
  const { setSelectedInsurance } = useContext(CheckoutContext);
  return (insurance) => {
    setSelectedInsurance(insurance);
    navigate("/checkout");
  };
};

